import { render, staticRenderFns } from "./cellDetailTemplate.vue?vue&type=template&id=160a4f13&"
import script from "./cellDetailTemplate.vue.js?vue&type=script&lang=js&"
export * from "./cellDetailTemplate.vue.js?vue&type=script&lang=js&"
import style0 from "./cellDetailTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports